/*
  DS Shop Card — swatch clicks. Not in the DS: the `.ds-shop-card`
  equivalent of assets/manmade-card-swatch.js (which is tied to Dawn's
  `.card` / `.card__content` markup), for the swatches rendered by
  snippets/manmade-card-swatches.liquid (shared with manmade-card-product-v3).
  Same behaviour: mark the clicked swatch selected, then show the hidden
  variant image whose data-value matches, falling back to the card's own
  image; with no variant images at all, go to the product instead. Loaded by
  sections/ds-shop-the-range.liquid only when swatches are on.
*/
document.addEventListener('click', (event) => {
  const swatch = event.target.closest('.ds-shop-card button.swatch');
  if (!swatch) return;

  event.preventDefault();
  event.stopPropagation();

  const card = swatch.closest('.ds-shop-card');
  const variantImages = card.querySelectorAll('.ds-shop-card__variant-img');

  if (variantImages.length === 0) {
    const link = card.querySelector('.ds-shop-card__link');
    if (link) window.location.href = link.href;
    return;
  }

  const wrapper = swatch.parentElement;
  Array.from(wrapper.parentElement.children).forEach((sibling) => {
    const selected = sibling === wrapper;
    sibling.classList.toggle('selected', selected);
    const button = sibling.querySelector('.swatch');
    if (button) button.setAttribute('aria-pressed', String(selected));
  });

  let match = null;
  variantImages.forEach((img) => {
    const isMatch = img.dataset.value === swatch.dataset.value;
    img.classList.toggle('is-active', isMatch && !match);
    if (isMatch && !match) match = img;
  });

  card.classList.toggle('ds-shop-card--variant-shown', Boolean(match));
});
